import React from "react";
import { API_URL } from "../../../config/api";

/**
 * Component hiển thị chi tiết bất động sản trong modal
 * @param {Object} property - Thông tin chi tiết của bất động sản
 * @param {Function} onClose - Hàm đóng modal
 */
const PropertyDetailModal = ({ property, onClose }) => {
    if (!property) return null;

    // Xử lý mảng ảnh (nếu là chuỗi JSON)
    let imagesArray = [];
    try {
        imagesArray = Array.isArray(property.images)
            ? property.images
            : JSON.parse(property.images || "[]");
    } catch {
        imagesArray = [];
    }

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
            onClick={onClose}
        >
            <div
                className="bg-white dark:bg-gray-900 rounded-lg max-w-4xl w-full p-6 relative max-h-[85vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Nút đóng */}
                <button
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white font-bold text-xl"
                    onClick={onClose}
                >
                    &times;
                </button>

                <h2 className="text-2xl font-bold mb-4 dark:text-white">
                    {property.title}
                </h2>

                {/* Ảnh bất động sản */}
                <div className="flex flex-wrap gap-3 mb-4">
                    {imagesArray.length > 0 ? (
                        imagesArray.map((img, i) => (
                            <img
                                key={i}
                                src={img.startsWith("http") ? img : `${API_URL}${img}`}
                                alt={`Ảnh ${i + 1}`}
                                className="w-40 h-32 object-cover rounded border border-gray-300 dark:border-gray-700"
                            />
                        ))
                    ) : (
                        <p className="dark:text-gray-300">Không có ảnh.</p>
                    )}
                </div>

                {/* Thông tin chi tiết */}
                <div className="space-y-2 text-gray-700 dark:text-gray-300 mb-4">
                    <p><strong>Dự án:</strong> {property.projectName || "Chưa cập nhật"}</p>
                    <p><strong>Nhà phát triển:</strong> {property.developer}</p>
                    <p><strong>Loại bất động sản:</strong> {property.propertyType}</p>
                    <p><strong>Block / Phân khu:</strong> {property.block || "-"}</p>
                    <p><strong>Mã căn:</strong> {property.unitCode || "-"}</p>
                    <p><strong>Tầng:</strong> {property.floor || "-"}</p>
                    <p><strong>Phòng ngủ:</strong> {property.bedrooms || "-"}</p>
                    <p><strong>Phòng tắm:</strong> {property.bathrooms || "-"}</p>
                    <p><strong>Diện tích:</strong> {property.area} m²</p>
                    <p><strong>Nội thất:</strong> {property.furniture}</p>
                    <p><strong>Hướng view:</strong> {property.view || "-"}</p>
                    <p><strong>Tình trạng bàn giao:</strong> {property.handoverStatus}</p>
                    <p><strong>Tình trạng pháp lý:</strong> {property.legalStatus}</p>
                    <p><strong>Giá:</strong> {property.price?.toLocaleString()} VNĐ</p>
                    <p><strong>Thanh toán:</strong> {property.paymentStatus || "-"}</p>
                    <p><strong>Loại hàng:</strong> {property.isPrimary ? "Chủ đầu tư" : "Ký gửi"}</p>
                    <p><strong>Trạng thái dự án:</strong> {property.projectStatus}</p>
                    <p><strong>Địa chỉ:</strong> {property.location}</p>
                    <p><strong>Tọa độ:</strong> {property.latitude}, {property.longitude}</p>

                    {/* Tiện ích */}
                    {property.amenities && (
                        <p>
                            <strong>Tiện ích:</strong>{" "}
                            {(() => {
                                let amenitiesArray = [];
                                try {
                                    amenitiesArray = Array.isArray(property.amenities)
                                        ? property.amenities
                                        : JSON.parse(property.amenities || "[]");
                                } catch {
                                    // Nếu là chuỗi phân tách bằng dấu phẩy
                                    amenitiesArray = typeof property.amenities === "string"
                                        ? property.amenities.split(",").map((a) => a.trim())
                                        : [];
                                }

                                return amenitiesArray.length > 0
                                    ? amenitiesArray.join(", ")
                                    : "Không có thông tin";
                            })()}
                        </p>
                    )}

                    <p><strong>Mô tả:</strong> {property.description || "-"}</p>
                    <p><strong>Trạng thái duyệt:</strong> {property.status}</p>
                    <p><strong>Đã bán:</strong> {property.isSold ? "Đã bán" : "Còn trống"}</p>

                    <p><strong>Người đăng:</strong> {property.user?.name || "Không rõ"}</p>
                    <p><strong>Ngày tạo:</strong> {new Date(property.createdAt).toLocaleString()}</p>
                    <p><strong>Ngày cập nhật:</strong> {new Date(property.updatedAt).toLocaleString()}</p>
                </div>

                {/* Nút Đóng */}
                <button
                    onClick={onClose}
                    className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded dark:bg-red-600 dark:hover:bg-red-700"
                >
                    Đóng
                </button>
            </div>
        </div>
    );
};

export default PropertyDetailModal;
